import React, { useState } from "react";
import { useSelector } from "react-redux";
import { t } from "i18next";
import StoreItem from "components/StoreItem";
import { QuantitySelector } from "components/item/Quantity";
import { HeadingText } from "components/TextTranslationContainer";
import { PriceRender } from "components/DisplayPrice";
import { DownArrow } from "config/Svgs";
import { RenderDiscountedPrice } from "components/DisplayPrice";

// TODO: remove basketList.js file once delivery and pickup are also revamped

const Addons = ({ addons, itemName }) => {
  const flatAddons = addons?.flatMap((addon) => addon?.options);
  return flatAddons?.map((addon, index) => (
    <div
      className="flex justify-between items-start gap-2 border-t border-gray-200 mt-2 pt-2 px-2"
      key={`addond-${index}-${addon?._id}`}
    >
      <div className="flex-1 flex flex-col gap-2">
        <h3 className="flex gap-2 text-14x font-bold">
          <span>{addon?.quantity}</span>
          <spa>x</spa>
          <span>{addon?.baseLanguage?.optionName}</span>
        </h3>
        <p className="text-12x text-gray-500">
          {addon?.baseLanguage?.optionDescription}
        </p>
      </div>
      <PriceRender price={addon?.price} />
      {/* <div>{item?.baseLanguage?.title}</div> */}
    </div>
  ));
};

const CollapseContainer = ({
  children,
  item,
  collapseId,
  index,
  listClassName = "",
  listStyle = {},
  as = "collapseAble",
  hideQunatitySelector = false,
  setCollapseId = () => {},
  decreaseItemQuantity = () => {},
  increaseItemQuantity = () => {},
}) => {

  const [collapsed, setCollapsed] = useState(true);

  const handleCollapse = (e) => {
    e.stopPropagation();
    if (item?.sections?.length <= 0) {
      return;
    }
    if (as === "collapseAble") {
      setCollapsed(!collapsed);
    } else {
      setCollapseId(item?.itemId?.itemId);
    }
  };

  const handleQuantityChange = (type) => {
    if (hideQunatitySelector) {
      return;
    }
    if (type === "decrease") {
      decreaseItemQuantity(item?._id, index);
    } else {
      increaseItemQuantity(item?._id, index);
    }
  };
  const isShowAddons =
    !collapsed || (collapseId ? collapseId === item?._id : false);

  return (
    <li className={listClassName} style={listStyle} onClick={handleCollapse}>
      <div className="flex-1 flex items-start gap-2">
        <StoreItem
          item={{ itemId: item }}
          mediaUrl={item?.mediaUrl}
          showPrice={false}
          displayQuantityInHeader={item?.quantity > 0}
          infoContent={
            <>
              {isShowAddons && (
                <Addons
                  addons={item?.sections}
                  itemName={item?.baseLanguage?.title}
                />
              )}
              <div className="flex justify-between items-center mt-4 gap-2">
                <QuantitySelector
                  value={item?.quantity}
                  disable={
                    (item?.isStockEnabled &&
                      item?.quantity + 1 > item?.availableStock) ||
                    hideQunatitySelector
                  }
                  showDisableMessage={false}
                  wrapperStyleProps={{
                    style: { padding: "0 12px", width: "76px" },
                  }}
                  quantityStyleProps={{
                    style: { width: "24px", margin: "0", textAlign: "center" },
                  }}
                  // disableMessage={t("Maximum available quantity reached")}
                  decreaseQuantity={() => handleQuantityChange("decrease")}
                  increaseQuantity={() => handleQuantityChange("increase")}
                />

                {!item?.discountOnItem?.discountedPrice && (
                  <PriceRender price={item?.price * item?.quantity} />
                )}
              </div>
              {item?.discountOnItem?.discountedPrice > 0 && (
                <div className="flex justify-between items-center mt-4 gap-2">
                  <RenderDiscountedPrice
                    price={{
                      ...item?.discountOnItem,
                      discountedPrice: item?.price * item?.quantity,
                      actualPrice:
                        item?.discountOnItem?.actualPrice * item?.quantity,
                    }}
                  />
                </div>
              )}
              {item?.discountOnItem?.discountInfoMessage && (
                 <p className="text-red-500 text-14x mb-2">
                 {t(item?.discountOnItem?.discountInfoMessage?.message, {
                   discount: item?.discountOnItem?.discountInfoMessage?.discount,
                   price: item?.discountOnItem?.discountInfoMessage?.price,
                   symbol: item?.discountOnItem?.discountInfoMessage?.symbol,
                 })}
               </p>
              )}
            </>
          }
        />
      </div>
      <div className="relative w-10  my-4 flex justify-end">
          {item?.sections?.length > 0 && (
            <DownArrow
            isArabicRotate={false}
            className={`cursor-pointer w-5 h-5 text-shadow-forge-700 hover:text-brand-base-primary transition-all duration-300 ${
              isShowAddons ? "rotate-180" : ""
            }`}
          />
        )}
        </div>
    </li>
  );
};

const BasketItemList = ({
  decreaseItemQuantity,
  increaseItemQuantity,
  containerStyleProps = {},
  ulProps = {},
  liItemProps = {},
  headerText = "Your Order",
  subHeaderText = "Add Items",
  onSubHeaderClick = () => {},
  showAllOrders = true,
}) => {
  const { cart } = useSelector((state) => state?.cart);
  const { ordered } = useSelector((state) => state?.order);
  const containerClasses = "basket-contents__items";
  const mergedContainerClass = `${containerClasses} ${
    containerStyleProps?.className || ""
  }`;
  const mergedContainerStyle = containerStyleProps?.style || {};

  const ulClassName = `basket-contents__item-list ${ulProps?.className || ""}`;
  const ulStyle = ulProps?.style || {};

  const liItemClassName = `no-select basket-item flex justify-between items-start flex-row flex-100 text-16x  ${
    liItemProps?.className || ""
  }`;
  const liItemStyle = liItemProps?.style || {};

  // uncomment if you want to use this as accordion
  // const [collapseId, setCollapseId] = useState(null);

  return (
    <div className={mergedContainerClass} style={mergedContainerStyle}>
      <div className="flex justify-between items-center mb-4">
        <HeadingText text={headerText} />
        {(cart?.length > 0 ||
          (ordered?.allOrders?.length > 0 &&
            ordered?.splitBills?.length < 1)) && (
          <button
            className="font-bold text-brand-base-primary cursor-pointer hover:font-semibold"
            onClick={onSubHeaderClick}
          >
            {t(subHeaderText)}
          </button>
        )}
      </div>

      {/* cart items */}
      <ul className={ulClassName} style={ulStyle}>
        {cart?.map((item, index) => (
          <CollapseContainer
            item={item}
            index={index}
            decreaseItemQuantity={decreaseItemQuantity}
            increaseItemQuantity={increaseItemQuantity}
            listClassName={`relative ${liItemClassName} ${
              index === cart.length - 1 ? "" : "mb-4"
            }`}
            listStyle={liItemStyle}
            key={`cart-${index}-${item?._id}`}
          />
        ))}
      </ul>
      {/* ordered items */}
      <ul>
        {showAllOrders &&
          ordered?.allOrders?.map((item, index) =>
            item?.orderedMenu?.map((order, index) => (
              <CollapseContainer
                item={order}
                index={index}
                listClassName={`relative ${liItemClassName} ${
                  index === cart.length - 1 ? "" : "mb-4"
                }`}
                listStyle={liItemStyle}
                key={`order-${index}-${order?._id}`}
                hideQunatitySelector={true}
              />
            ))
          )}
      </ul>
    </div>
  );
};

export default BasketItemList;
